/** PURE_IMPORTS_START .._.._Observable,.._.._observable_if PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { _if } from '../../observable/if';
Observable.if = _if;
//# sourceMappingURL=if.js.map 



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/add/observable/if.js
// module id = 384
// module chunks = 0